import React from "react";
import { Alert, AlertTitle, Link } from "@mui/material";

export function CancelAppointmentFailure(props) {
  const statusMessage = props.result;

  return (
    <Alert
      severity="error"
      variant="filled"
      sx={{
        mt: {
          xs: 3,
          sm: 2,
        },
        mb: 2,
      }}
    >
      <AlertTitle>Error</AlertTitle>
      We have not been able to cancel your appointment, please try again later,
      or contact us{" "}
      <Link
        href="https://www.connecthealth.co.uk/contact/"
        target="_blank"
        rel="noopener"
        color="inherit"
        underline="always"
      >
        here
      </Link>{" "}
      and quote the below error.
      <strong>{statusMessage}</strong>
    </Alert>
  );
}
